export const testimonials = {
  it: {
    title: "Testimonianze dei Clienti"
  },
  en: {
    title: "Client Testimonials"
  }
};